import React from "react"
import autobind from "class-autobind"
import { browserHistory } from "react-router"
import AppStateStore from "../../stores/AppStateStore"
import TimecardPunchControl from "./TimecardPunchControl"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as permissionHelper from "../../helpers/permissionHelper"
import { ITimecardDay, IPunchSetDocument } from "../../models"
import PunchDetailsDialog from "../punch/PunchDetailsDialog"
import strings from "../../localization/strings"
import moment from "moment"
import * as timeHelper from "../../helpers/timeHelper"
interface IProps {
    day: ITimecardDay
    timecardLocked: boolean
    readonly: boolean
    punchSet: IPunchSetDocument
    addPunch(day: ITimecardDay, hierarchyItemId: string, positionId: string, payClassId: string, payTypeId: string, employeeId: string, shiftId: string, jobId: string, phaseId: string, isPunchIn: boolean, pairedPunchId: string): void
    onConfirmDelete(punchId: string): void
    onTimeChange(punchId: string, dateTime: Date | string, errorCb: () => void): void
    reloadTimecard(msg: string): void
}
interface IState {
    punchIdForDetailDialog: string
}

export default class EquipmentTimecardTablePSCell extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            punchIdForDetailDialog: null,
        }
        autobind(this)
    }

    getBreakDurationString(breakObj) {
        //Positive minute values take away from the duration. Negative add.
        if (breakObj.BreakDurationInMinutes > 0) {
            return "- " + breakObj.BreakDurationInMinutes + "m"
        } else {
            return "+ " + breakObj.BreakDurationInMinutes + "m"
        }
    }
    render() {
        const actualPunchInTime = timeHelper.keepConvertUTCToLocal(this.props.punchSet.PunchInTimeLocal)
        const punchInTime = this.props.punchSet.RoundingRuleId ?
            timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundedPunchInTimeLocal) :
            actualPunchInTime

        const actualPunchOutTime = timeHelper.keepConvertUTCToLocal(this.props.punchSet.PunchOutTimeLocal)
        const punchOutTime = this.props.punchSet.RoundingRuleId ?
            timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundedPunchOutTimeLocal) :
            actualPunchOutTime

        let autoBreaks
        let employeeName
        const subPunchSetTextStyle = { fontSize: "7pt", marginTop: -5, color: "#aaaaaa", float: "left", cursor: "pointer" }

        if (this.props.punchSet.UserId != null) {
            employeeName = (
                <div
                    style={subPunchSetTextStyle}
                    onClick={() => {
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees) && browserHistory.push("/user-details/" + this.props.punchSet.UserId + "/timecards")
                    }}
                >
                    <i className="fa fa-user" /> {this.props.punchSet.EmployeeName.toUpperCase()}
                </div>
            )
        }

        if (this.props.punchSet.AutoBreaks && this.props.punchSet.AutoBreaks.length > 0) {
            let breaksText = ""
            for (let i = 0; i < this.props.punchSet.AutoBreaks.length; i++) {
                breaksText += (this.props.punchSet.AutoBreaks[i].BreakName ? this.props.punchSet.AutoBreaks[i].BreakName.toUpperCase() : "Auto Break") + ": " + this.getBreakDurationString(this.props.punchSet.AutoBreaks[i])
            }

            autoBreaks = (
                <div style={subPunchSetTextStyle}>
                    {this.props.punchSet.AutoBreaks.map((autoBreak, i) =>
                        <div key={i}>
                            <i className="fa fa-check" /> {(autoBreak.BreakName ? autoBreak.BreakName.toUpperCase() : "Auto Break") + ": " + this.getBreakDurationString(autoBreak)}
                        </div>
                    )}
                </div>
            )
        }
        return (
            <div>
                <div style={{ display: !AppStateStore.isLaptop() && "flex" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {AppStateStore.isLaptop() &&
                            <span style={{ display: "inline-block", fontSize: "7pt", marginRight: 5, width: 15 }}>
                                IN
                            </span>
                        }
                        <TimecardPunchControl
                            key={"in" + this.props.punchSet.Id}
                            hintText="IN"
                            systemModified={this.props.punchSet.InTimeSystemAddedUpdated}
                            modified={this.props.punchSet.InTimeManuallyAddedUpdated}
                            timeChanged={this.props.punchSet.InTimeChanged}
                            value={punchInTime}
                            actualValue={actualPunchInTime}
                            onRemovePunch={() => this.props.onConfirmDelete(this.props.punchSet.PunchInId)}
                            punchId={this.props.punchSet.PunchInId}
                            punchSet={this.props.punchSet}
                            handleUpdatePunchTime={this.props.onTimeChange}
                            readonly={this.props.timecardLocked || this.props.readonly}
                            handleOpenPunchDetailDialog={() => this.setState({ punchIdForDetailDialog: this.props.punchSet.PunchInId })}
                            timeFraud={this.props.punchSet.InTimeFraud}
                        />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {AppStateStore.isLaptop() &&
                            <span style={{ display: "inline-block", fontSize: "7pt", marginRight: 5, width: 15 }}>
                                OUT
                            </span>
                        }
                        <TimecardPunchControl
                            key={"out" + this.props.punchSet.Id}
                            hintText="+ OUT"
                            systemModified={this.props.punchSet.OutTimeSystemAddedUpdated}
                            modified={this.props.punchSet.OutTimeManuallyAddedUpdated}
                            timeChanged={this.props.punchSet.OutTimeChanged}
                            value={punchOutTime}
                            actualValue={actualPunchOutTime}
                            onAddPunch={() => this.props.addPunch(this.props.day, this.props.punchSet.HierarchyItemId, this.props.punchSet.PositionId, this.props.punchSet.PayClassId, this.props.punchSet.PayTypeId, this.props.punchSet.UserId, this.props.punchSet.ShiftId, this.props.punchSet.JobId, this.props.punchSet.PhaseId, false, this.props.punchSet.PunchInId)}
                            onRemovePunch={() => this.props.onConfirmDelete(this.props.punchSet.PunchOutId)}
                            punchId={this.props.punchSet.PunchOutId}
                            punchSet={this.props.punchSet}
                            handleUpdatePunchTime={this.props.onTimeChange}
                            readonly={this.props.timecardLocked || this.props.readonly}
                            missingPunch={!this.props.punchSet.PunchOutId}
                            handleOpenPunchDetailDialog={() => this.setState({ punchIdForDetailDialog: this.props.punchSet.PunchOutId })}
                            timeFraud={this.props.punchSet.OutTimeFraud}
                        />
                    </div>
                </div>
                {employeeName}
                {autoBreaks}
                {this.props.punchSet.OverrideDayGroupingTime &&
                    <div style={subPunchSetTextStyle}>
                        <div style={{ marginRight: 5 }}>
                            {strings.PUNCH_IN_DATE}: {moment(timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundingRuleId ? this.props.punchSet.RoundedPunchInTimeLocal : this.props.punchSet.PunchInTimeLocal)).format("MM-DD-YYYY")}
                        </div>
                    </div>
                }
                <div style={{ clear: "both" }} />
                {this.state.punchIdForDetailDialog &&
                    <PunchDetailsDialog
                        callingByEquipment
                        onRequestClose={() => this.setState({ punchIdForDetailDialog: null })}
                        punchId={this.state.punchIdForDetailDialog}
                        punchSet={this.props.punchSet}
                        reloadTimecard={this.props.reloadTimecard}
                        readonly={this.props.readonly}
                        onRemovePunch={() => {
                            this.props.onConfirmDelete(this.state.punchIdForDetailDialog)
                            this.setState({ punchIdForDetailDialog: null })
                        }}
                    />
                }
            </div>
        )
    }
}
